import { render, staticRenderFns } from "./DailyWord.vue?vue&type=template&id=2d98c754&"
import script from "./DailyWord.vue?vue&type=script&lang=js&"
export * from "./DailyWord.vue?vue&type=script&lang=js&"
import style0 from "./DailyWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports